import { render, staticRenderFns } from "./UnReadNotificationsModal.vue?vue&type=template&id=0218d2df&scoped=true&lang=pug"
import script from "./UnReadNotificationsModal.vue?vue&type=script&lang=ts"
export * from "./UnReadNotificationsModal.vue?vue&type=script&lang=ts"
import style0 from "./UnReadNotificationsModal.vue?vue&type=style&index=0&id=0218d2df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0218d2df",
  null
  
)

export default component.exports